
<div v-if="show" class="EntityDetailsQuickActions">
    <h3 class="quick-actions-title">Schnellaktionen</h3>
    <div class="quick-actions-grid">
        <Button
            v-for="action in visibleActions"
            :key="action.key"
            variant="outline"
            size="small"
            @onClick="handleNavigate(action.page)"
        >
            <i :class="action.icon" style="margin-right: 4px"></i>
            <span>{{ action.label }}</span>
            <span class="button-hotkey">{{ action.hotkey }}</span>
        </Button>
    </div>
</div>
